import { useQuery } from '@tanstack/react-query';
import { ActorsApi } from 'src/api';

export const useActorProfile = (languagePairId: number, actorId: number | null, enabled = true) =>
  useQuery({
    queryKey: ['actorProfile', languagePairId, actorId],
    queryFn: () => ActorsApi.getActorProfile(languagePairId, actorId as number),
    enabled: enabled && actorId !== null,
  });
